import React from 'react';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography/Typography';
import Divider from '@mui/material/Divider/Divider';
import WikiHelpIcon from '../../../../components/wiki/WikiHelpIcon';

interface IViewWrapperProps {
  title: string;
  courseTitle: string;
  wikiTooltipID?: string;
  children: React.ReactNode;
}
export default function ViewWrapper({ title, courseTitle, wikiTooltipID, children }: IViewWrapperProps) {
  const theme = useTheme();

  return (
    <>
      <div
        style={{
          flex: '1 1 auto',
          marginLeft: theme.spacing(10),
          marginRight: theme.spacing(10),
          marginTop: theme.spacing(5),
          marginBottom: theme.spacing(5),
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row', gap: theme.spacing(4), marginBottom: theme.spacing(2) }}>
          <div style={{ width: 'max-content', display: 'flex', flexDirection: 'column', gap: 4 }}>
            <Typography variant='h5'>{title}</Typography>
            <Divider sx={{ borderColor: theme.palette.darkGray.main }} />
            <Typography sx={{ color: theme.palette.darkGray.main }}>{courseTitle}</Typography>
          </div>
          <div style={{ marginTop: '3px' }}>{wikiTooltipID && <WikiHelpIcon tooltipId={wikiTooltipID} />}</div>
        </div>
        <div
          style={{
            display: 'flex',
            flex: '1 1 auto',
            overflow: 'hidden',
          }}
        >
          {children}
        </div>
      </div>
    </>
  );
}
